import type { MessageType } from "@lib/campaignMessageTypeConstants";
import sharedConstants from "@lib/shared_constants";

import { getChannelForMessageType } from "./getChannelForMessageType";
import { pushPlatformsIn } from "./pushPlatformsIn";
import type { ContentOptimizationDuplicateChannelSelection } from "./types";

/** Message types as they arrive from loosely typed canvas step data. */
export type DuplicateChannelSelectionMessageTypes = readonly (MessageType | null | undefined)[];

const quickPushCompositionModes: ReadonlySet<string> = new Set([
  sharedConstants.CAMPAIGNS.COMPOSITION_MODE_TYPE.QUICK_PUSH,
  sharedConstants.CAMPAIGNS.COMPOSITION_MODE_TYPE.QUICK_PUSH_MULTICHANNEL,
]);

/**
 * Builds the duplicate-as-CO choices shown in the channel selection modal. Quick push composes
 * every platform as a single message, so those steps offer one "push" choice; elsewhere each
 * push platform present is its own choice once there is more than one. Choices are ordered
 * email, push, sms, with push platforms in the order they appear on the step.
 */
export const getContentOptimizationDuplicateChannelSelections = (
  compositionMode: string | undefined,
  messageTypes: DuplicateChannelSelectionMessageTypes
): ContentOptimizationDuplicateChannelSelection[] => {
  const pushPlatforms = pushPlatformsIn(messageTypes);
  const splitPushPlatforms =
    !(compositionMode && quickPushCompositionModes.has(compositionMode)) && pushPlatforms.size > 1;

  const channels: ContentOptimizationDuplicateChannelSelection[] = [];

  if (messageTypes.some((messageType) => getChannelForMessageType(messageType) === "email")) {
    channels.push("email");
  }

  if (splitPushPlatforms) {
    channels.push(...pushPlatforms);
  } else if (messageTypes.some((messageType) => getChannelForMessageType(messageType) === "push")) {
    channels.push("push");
  }

  if (messageTypes.some((messageType) => getChannelForMessageType(messageType) === "sms")) {
    channels.push("sms");
  }

  return channels;
};
